var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconParticipant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E5F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F2F8F8",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22866_22365)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.637 18.3589C28.3948 17.3825 27.8428 16.5085 27.061 15.8695C26.2275 15.1883 25.184 14.8161 24.1076 14.8161C23.0311 14.8161 21.9877 15.1883 21.1542 15.8695C20.9727 16.0179 20.8036 16.1789 20.6479 16.3509C21.6109 16.5257 22.5465 16.9404 23.3091 17.703C23.5968 17.9907 23.835 18.3031 24.0295 18.6322C25.5598 18.6355 27.0896 18.5443 28.637 18.3589Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4425 25.3507C23.2243 25.9897 23.7763 26.8637 24.0186 27.8401C24.0186 27.8401 21.2798 28.1971 19.4891 28.1971C17.6984 28.1971 14.9597 27.8401 14.9597 27.8401C15.202 26.8637 15.754 25.9897 16.5358 25.3507C17.3693 24.6695 18.4126 24.2972 19.4891 24.2972C20.5656 24.2972 21.609 24.6695 22.4425 25.3507Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4886 24.2973C21.2639 24.2973 22.2625 23.2987 22.2625 21.5234C22.2625 19.7482 21.2639 18.7496 19.4886 18.7496C17.7133 18.7496 16.7148 19.7482 16.7148 21.5234C16.7148 23.2987 17.7133 24.2973 19.4886 24.2973Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0186 27.84C23.7763 26.8635 23.2243 25.9895 22.4425 25.3505C21.609 24.6693 20.5656 24.2971 19.4891 24.2971C18.4126 24.2971 17.3693 24.6693 16.5358 25.3505C15.754 25.9895 15.202 26.8635 14.9597 27.84",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4886 24.2973C21.2639 24.2973 22.2625 23.2987 22.2625 21.5234C22.2625 19.7482 21.2639 18.7496 19.4886 18.7496C17.7133 18.7496 16.7148 19.7482 16.7148 21.5234C16.7148 23.2987 17.7133 24.2973 19.4886 24.2973Z",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1075 14.8163C25.8828 14.8163 26.8813 13.8177 26.8813 12.0424C26.8813 10.2672 25.8828 9.26855 24.1075 9.26855C22.3321 9.26855 21.3335 10.2672 21.3335 12.0424C21.3335 13.8177 22.3321 14.8163 24.1075 14.8163Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1075 14.8163C25.8828 14.8163 26.8813 13.8177 26.8813 12.0424C26.8813 10.2672 25.8828 9.26855 24.1075 9.26855C22.3321 9.26855 21.3335 10.2672 21.3335 12.0424C21.3335 13.8177 22.3321 14.8163 24.1075 14.8163Z",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.637 18.3589C28.3948 17.3825 27.8428 16.5085 27.061 15.8695C26.2276 15.1883 25.1842 14.8161 24.1076 14.8161C23.0312 14.8161 21.9878 15.1883 21.1543 15.8695",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0659 18.3589C10.3082 17.3825 10.8602 16.5085 11.642 15.8695C12.4755 15.1883 13.5188 14.8161 14.5953 14.8161C15.6718 14.8161 16.7152 15.1883 17.5487 15.8695C17.7302 16.0179 17.8993 16.1789 18.0551 16.3509C17.0921 16.5257 16.1564 16.9404 15.3939 17.703C15.1061 17.9907 14.8679 18.3031 14.6735 18.6322C13.1432 18.6355 11.6133 18.5443 10.0659 18.3589Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5956 14.8163C12.8203 14.8163 11.8217 13.8177 11.8217 12.0424C11.8217 10.2672 12.8203 9.26855 14.5956 9.26855C16.3708 9.26855 17.3694 10.2672 17.3694 12.0424C17.3694 13.8177 16.3708 14.8163 14.5956 14.8163Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5956 14.8163C12.8203 14.8163 11.8217 13.8177 11.8217 12.0424C11.8217 10.2672 12.8203 9.26855 14.5956 9.26855C16.3708 9.26855 17.3694 10.2672 17.3694 12.0424C17.3694 13.8177 16.3708 14.8163 14.5956 14.8163Z",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0659 18.3589C10.3082 17.3825 10.8602 16.5085 11.6419 15.8695C12.4754 15.1883 13.5188 14.8161 14.5953 14.8161C15.6718 14.8161 16.7152 15.1883 17.5487 15.8695",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22866_22365"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(9.35147 8.55426)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconParticipant);
export default __webpack_public_path__ + "static/media/MetricIconParticipant.1b653ec2b86bd319f280dac1b05ccca2.svg";
export { ForwardRef as ReactComponent };